import React from 'react'
import { connect } from 'react-redux'
import { actions } from './redux/ducks/main'
import styled from 'styled-components'
import PiLogo from './components/PiLogo'
import GlobalModal from './components/GlobalModal'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/de'

dayjs.locale('de')
dayjs.extend(relativeTime)

const inactiveColor = '#779'
const activeColor = '#dd0';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
`

const Switch = styled.button`
  width: 80px;
  height: 32px;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  opacity: ${({ disabled }) => disabled ? 0.4 : 1};
  background-color: ${({ active }) => active ? activeColor : inactiveColor};
`

const Label = styled.span`
  margin-right: 10px;
`

const LabelledSwitch = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  color: '#111';
`

const SwitchWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-around;
  min-width: 75vw;
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-bottom: 16px;
  > h1 {
    margin: 0;
    margin-left: 10px;
    font-size: 20px;
    line-height: 22px;
  }
`

const Info = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
`
const InfoLabel = styled.div`
  font-weight: bold;
  text-align: right;
`

const readingIsInLast24h = (reading) => {
  const oneDayAgo = new Date().getTime() - 1000 * 60 * 60 * 24
  return new Date(reading) > oneDayAgo
}

const App = ({ gpioState, sensor, pendingGpioState, toggleGpio }) => <Root>
  <GlobalModal />
  <Header>
    <PiLogo height={22} />
    <h1>MPI Control</h1>
  </Header>
  {sensor && readingIsInLast24h(sensor.lastReading)
    ? <Info>
      <InfoLabel>Letzte Messung</InfoLabel><div>{dayjs(sensor.lastReading).fromNow()}</div>
      <InfoLabel>Wassertank-Füllstand</InfoLabel><div>{sensor.waterLevel} %</div>
      <InfoLabel>Außentemperatur</InfoLabel><div>{sensor.temperature} °C</div>
      <InfoLabel>Max. (letzte 24h)</InfoLabel><div>{sensor.maxTemp24h} °C</div>
      <InfoLabel>Min. (letzte 24h)</InfoLabel><div>{sensor.minTemp24h} °C</div>
    </Info>
    : <div>Keine Messwerte in den letzten 24h</div>
  }
  <SwitchWrap>
    <LabelledSwitch>
      <Label>Wasserpumpe</Label>
      <Switch
        active={gpioState.get('pump')}
        disabled={pendingGpioState}
        onClick={() => toggleGpio('pump')}
      >{gpioState.get('pump') ? 'EIN' : 'AUS'}</Switch>
    </LabelledSwitch>
    <LabelledSwitch>
      <Label>Wohnzimmer</Label>
      <Switch
        active={gpioState.get('living')}
        disabled={pendingGpioState}
        onClick={() => toggleGpio('living')}
      >{gpioState.get('living') ? 'EIN' : 'AUS'}</Switch>
    </LabelledSwitch>
    <LabelledSwitch>
      <Label>Gartenbeleuchtung</Label>
      <Switch
        active={gpioState.get('garden')}
        disabled={pendingGpioState}
        onClick={() => toggleGpio('garden')}
      >{gpioState.get('garden') ? 'EIN' : 'AUS'}</Switch>
    </LabelledSwitch>
    <LabelledSwitch>
      <Label>Gartenweg</Label>
      <Switch
        active={gpioState.get('terraceDown')}
        disabled={pendingGpioState}
        onClick={() => toggleGpio('terraceDown')}
      >{gpioState.get('terraceDown') ? 'EIN' : 'AUS'}</Switch>
    </LabelledSwitch>
    <LabelledSwitch>
      <Label>Kleine Terrasse</Label>
      <Switch
        active={gpioState.get('terraceUp')}
        disabled={pendingGpioState}
        onClick={() => toggleGpio('terraceUp')}
      >{gpioState.get('terraceUp') ? 'EIN' : 'AUS'}</Switch>
    </LabelledSwitch>
  </SwitchWrap>
</Root>

export default connect(
  state => ({
    gpioState: state.main.gpioState,
    sensor: state.main.gpioState.get('sensor') && state.main.gpioState.get('sensor').toJS(),
    pendingGpioState: state.main.pendingGpioState
  }),
  dispatch => ({
    toggleGpio: key => dispatch(actions.toggleGpio({ key }))
  })
)(App)
